import React from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import productsbanner from '../assets/productsbanner.png';
import '../style/product.css';
import productspage1 from '../assets/productspage1.png';
import productspage2 from '../assets/productspage2.png';
import productspage3 from '../assets/productspage3.png';
import productspage4 from '../assets/productspage4.png';
import clearall from '../assets/clear_all.png';
import bookmark from '../assets/bookmarks.png';
import searchicon from '../assets/search.png';
import product1 from '../assets/product1.png';
import product2 from '../assets/product2.png';
import product3 from '../assets/product3.png';
import product4 from '../assets/product4.png';
import product5 from '../assets/product5.png';
import product6 from '../assets/product6.png';
import bestmatch from '../assets/bestmatch.png';
import Map from '../assets/Map.png';

const products = [
  {
    id: 1,
    name: "Wireless Headphones",
    description: "Lorem bring together hundreds vendors under one roof giving your vast catalogs",
    price: 500,
    image: product1,
  },
  {
    id: 2,
    name: "Smart Watch",
    description: "Lorem bring together hundreds vendors under one roof giving your vast catalogs",
    price: 586,
    image: product2,
  },
  {
    id: 3,
    name: "Bluetooth Speaker",
    description: "Lorem bring together hundreds vendors under one roof giving your vast catalogs",
    price: 972,
    image: product3,
  },
  {
    id: 4,
    name: "Multiple Vendors Meet Your Needs",
    description: "Lorem bring together hundreds vendors under one roof giving your vast catalogs",
    price: 500,
    image: product4,
  },
  {
    id: 5,
    name: "Multiple Vendors Meet Your Needs",
    description: "Lorem bring together hundreds vendors under one roof giving your vast catalogs",
    price: 586,
    image: product5,
  },
  {
    id: 6,
    name: "Multiple Vendors Meet Your Needs",
    description: "Lorem bring together hundreds vendors under one roof giving your vast catalogs",
    price: 972,
    image: product6,
  },
];

const ProductCard = ({ product }) => (
  <Col md="4" key={product.id}>
    <div className='productmain'>
      <Link to={`/product/${product.id}`}>
        <img src={product.image} alt={product.name}/>
        <div className='bestmatch'><img src={bestmatch} alt="Best match"/></div>
        <h4>${product.price.toFixed(2)}</h4>
        <h5>{product.name}</h5>
        <p>{product.description}</p>
        <a href='#'>Buy Offers possibilities</a>
      </Link>
    </div>
  </Col>
);

const Products = () => {
  return (
    <div>
      <section className="productpagebanner">
        <Container>
          <Row>
            <Col md="12">
              <div className="homebanner">
                <h1>Personalised and Custom Groceries</h1>
                <img src={productsbanner} alt="Products banner"/>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      
      <section className="treandingfarmers">
        <Container>
          <Row>
            <Col md="3">
              <div className="boxcategory">
                <img src={productspage1} alt="Local Farmers"/> 
                <h2>Local Farmers</h2>
                <Link to="#">Shop Now</Link>
              </div>
            </Col>
            <Col md="3">
              <div className="boxcategory">
                <img src={productspage2} alt="Market Places"/> 
                <h2>Market Places</h2>
                <Link to="#">Shop Now</Link>
              </div>
            </Col>
            <Col md="3">
              <div className="boxcategory">
                <img src={productspage3} alt="Trending"/> 
                <h2>Trending</h2>
                <Link to="#">Shop Now</Link>
              </div>
            </Col>
            <Col md="3">
              <div className="boxcategory">
                <img src={productspage4} alt="Featured"/> 
                <h2>Featured</h2>
                <Link to="#">Shop Now</Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      
      <section className="products vreifiedvendors vreifiedvendorssection">
        <Container>
          <Row>
            <Col md="12">
              <h2>Shop Directly from <span>Verified Vendors</span></h2>
            </Col>
          </Row>
          <Row className='searchform'>
            <Col md="5">
              <div className='shopbestmatch'>
                <ul>
                  <li><img src={clearall} alt="Clear all"/></li>
                  <li><img src={bookmark} alt="Bookmark"/></li>
                  <li><Link to='#'>Best Match</Link></li>
                  <li><Link to='#'>Newest</Link></li>
                  <li><Link to='#'>Trending</Link></li>
                </ul>
              </div>
            </Col>
            <Col md="7">
              <div className="search-bar">
                <select className="filter-dropdown">
                  <option value="latest">Latest</option>
                  <option value="popular">Popular</option>
                  <option value="trending">Trending</option>
                </select>
                <input
                  type="text"
                  className="search-input"
                  placeholder="Search Bringing Vendors Together........"
                />
                <button className="search-button">
                  <img src={searchicon} alt="Search"/>
                </button>
              </div>
            </Col>
          </Row>
          <Row>
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
            <div className="productsbutton">
              <Link to="#">See More</Link>
            </div>
          </Row>
        </Container>
      </section>

      <section className="vendorsmap">
        <Container>
          <Row>
            <Col md="7">
              <h2>Find Vendors on the Map & Visit Their Profiles</h2>
            </Col>
            <Col md="5">
              <p>Browse vendor profiles, see what they're selling, and place orders directly. Whether you're looking for fresh vegetables, organic honey, or handmade crafts, find everything in one place.</p>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <img src={Map} alt="Vendors map"/>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Products;